import { useState } from 'react'
import { ButtonGroup } from 'stories/components'

import { ServicingChargeCategories } from './ChargeCategories'
import { CollectionsDialerConfiguration } from './Dialer'
import { ExtensionDefaultsConfiguration } from './ExtensionDefaults'
import { HolidaysConfiguration } from './Holidays'
import { PayoffDefaultsConfiguration } from './PayoffDefaults'
import { PrepaymentPenaltyConfiguration } from './PrepaymentPenalty'
import { RateIndexesConfiguration } from './RateIndexes'
import { StatementDefaultsConfiguration } from './StatementDefaults'
import { ServicingWorkflowConfiguration } from './Workflow'

const tabs = {
  calendar: 'Calendar',
  prepaymentPenalty: 'Prepayment Penalty',
  chargeCategories: 'Charge Categories',
  rateIndexes: 'Rate Indexes',
  payoffDefaults: 'Payoff Defaults',
  extensionDefaults: 'Extension Defaults',
  statementDefaults: 'Statement Defaults',
  workflow: 'Workflow',
  calling: 'Calling',
}

export const ServicingConfiguration = () => {
  const [tab, setTab] = useState('calendar')

  const renderContent = () => {
    switch (tab) {
      case 'calendar':
        return <HolidaysConfiguration />
      case 'prepaymentPenalty':
        return <PrepaymentPenaltyConfiguration />
      case 'chargeCategories':
        return <ServicingChargeCategories />
      case 'rateIndexes':
        return <RateIndexesConfiguration />
      case 'payoffDefaults':
        return <PayoffDefaultsConfiguration />
      case 'extensionDefaults':
        return <ExtensionDefaultsConfiguration />
      case 'statementDefaults':
        return <StatementDefaultsConfiguration />
      case 'workflow':
        return <ServicingWorkflowConfiguration />
      case 'calling':
        return <CollectionsDialerConfiguration />
    }
  }

  return (
    <div>
      <ButtonGroup title={tabs} value={tab} onChange={setTab} />
      {renderContent()}
    </div>
  )
}
